import { useState, useEffect } from 'react'

export const useDebounce = (value, timeout, shouldDebounce = true) => {
  const [state, setState] = useState(value)

  useEffect(() => {
    if (!shouldDebounce) return

    const handler = setTimeout(() => setState(value), timeout)

    return () => clearTimeout(handler)
  }, [value, timeout])

  return [state, setState]
}
